import { getDateInUserTimezone } from '../../utils/dates';
import { Activity } from '../../activities';

// TODO: Remove from here

const filterByDates: FilterByDatesType = (activities, dates, eventDays) => {
    if (dates.length === 0) {
        return activities;
    }

    const activitiesFilteredByDates = activities.filter(({ startDateUTCTimestamp }) => {
        const startDateInUserTimezone = getDateInUserTimezone(startDateUTCTimestamp);
        return dates.includes(startDateInUserTimezone);
    });

    const unscheduledActivities = activities.filter(({ isScheduled }) => !isScheduled);

    const lastEventDay = eventDays[eventDays.length - 1]?.value ?? 0;
    const lastActivityDate = activities.reduce((max, { startDateUTCTimestamp }) => {
        if (!startDateUTCTimestamp) {
            return max;
        }
        const startDateInUserTimezone = getDateInUserTimezone(startDateUTCTimestamp);
        return max > startDateInUserTimezone ? max : startDateInUserTimezone;
    }, 0);

    const dayForUnscheduledSessions =
        lastEventDay > lastActivityDate ? lastEventDay : lastActivityDate;

    const result = dates.includes(dayForUnscheduledSessions)
        ? [...activitiesFilteredByDates, ...unscheduledActivities]
        : activitiesFilteredByDates;

    return result;
};

export const filterByTags: FilterByTagsType = (activities, tags) => {
    const activitiesFilteredByTags = activities.filter(({ filters = [] }) => {
        const test = tags.reduce((acc, group) => {
            const activityFilter = filters.find(({ id }) => group.id === id);
            if (!activityFilter) {
                return false;
            }

            const tagTest = group.tags.some(tag => activityFilter.tags.includes(Number(tag)));

            return acc && tagTest;
        }, true);
        return test;
    });

    return activitiesFilteredByTags;
};

const filterActivities: FilterActivitiesType = (data, { dates = [], tags = [] }, eventDays) => {
    let filteredActivities = filterByDates(data, dates, eventDays);

    filteredActivities = filterByTags(filteredActivities, tags);

    return filteredActivities;
};

type FilterActivitiesType = (
    data: Activity[],
    filters: { dates: number[]; tags: TagGroupType[] },
    eventDays: Array<{ value: number; label: string }>
) => Activity[];

type TagGroupType = { id: number; tags: (number | string)[] };

type FilterByTagsType = (activities: Activity[], tags: TagGroupType[]) => Activity[];

type FilterByDatesType = (
    activities: Activity[],
    dates: number[],
    eventDays: Array<{ value: number; label: string }>
) => Activity[];

export const normalizeFilters: NormalizeFiltersType = (filters, tagsInfo) => {
    const dates = filters.dates;

    const tags = Object.entries(filters.tags)
        .filter(([, options]) => options.length > 0)
        .map(([key, tags]) => {
            const { id } = tagsInfo.find(({ name }) => name === key);
            return { id, tags };
        });

    return { dates, tags };
};

type NormalizeFiltersType = (
    filters: FiltersType,
    tagsInfo?: Array<{
        name: string;
        id: number;
    }>
) => {
    dates: number[];
    tags: TagGroupType[];
};

type OptionType = number;

type FiltersType = {
    dates?: number[];
    tags?: Record<string, OptionType[]>;
};

export default filterActivities;
